import { Injectable } from '@angular/core';
import { SweetAlertOptions } from 'sweetalert2';
import { escape } from 'lodash-es';


@Injectable()
export class TemplateModalService {
  private sweetAlertOptions: SweetAlertOptions;

  constructor() {
  }

  public getSuccessAlertOptions(successTitle: string, message: string, recordType: string) {
    return this.sweetAlertOptions = {
      title: successTitle,
      icon: 'success',
      buttonsStyling: false,
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonText: `View ${recordType}`,
      customClass: {
        confirmButton: 'btn btn-secondary mr-3'
      },
      html: this.getSuccessTemplate(message)
    };
  }

  public getInactivityOptions(title: string, message: string) {
    return this.sweetAlertOptions = {
      title: title,
      buttonsStyling: false,
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Ok',
      customClass: {
        confirmButton: 'btn btn-secondary mr-3'
      },
      html: this.getInactivityTemplate(message)
    };
  }

  public genericAlert(title: string, message: string, icon?: string): SweetAlertOptions {
    return this.sweetAlertOptions = {
      title: title,
      buttonsStyling: false,
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Ok',
      customClass: {
        confirmButton: 'btn btn-secondary mr-3'
      },
      html: this.getGenericTemplate(message, icon)
    };
  }

  public getConfirmationTemplate(message: string, record: string, recordName: string) {
    return `
      <div class="body">
         <h2>${message}</h2>
         <div class="details">
           <p><b>${record}: </b>${this.escapeHtml(recordName)}</p>
         </div>
      </div>`;
  }

  public getSuccessTemplate(message: string) {
    return `
      <div class="body success">
        <p><strong>Success!</strong></p>
        <div class="details">
          <p>${message}</p>
        </div>
      </div>`;
  }

  public getInactivityTemplate(message: string) {
    return `
      <div class="body">
        <div class="details">
          <p><i class="fa fa-clock-o" aria-hidden="true"></i> ${message}</p>
        </div>
      </div>`;
  }

  public getGenericTemplate(message: string, icon = 'warning'): string {
    return `
      <div class="body">
        <div class="details">
          <p><i class="fa fa-${icon}" aria-hidden="true"></i> ${message}</p>
        </div>
      </div>`;
  }

  /**
   * Escapes HTML-significant characters so stored, user-influenced values (e.g. record names)
   * can be safely interpolated into SweetAlert2's `html` option, which renders raw innerHTML.
   */
  private escapeHtml(value: string): string {
    if (value === null || value === undefined) {
      return value;
    }
    return escape(value);
  }

}
